import { Component, OnInit, Input } from '@angular/core';

// env
import { environment } from './../../../environments/environment';

@Component({
  selector: 'app-docs',
  templateUrl: './docs.component.html',
  styles: [
  ]
})
export class DocsComponent implements OnInit {

  @Input() dataDocs;
  apiAsset = environment.API_ASSETS;
  constructor() { }

  ngOnInit(): void {
  }

}
